/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from './vuetify';
import pinia from '../stores';
import router from '../router';
import VueCookies from 'vue-cookies';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
// Types
import type { App } from 'vue';
import initI18n from './i18n';

export function registerPlugins(app: App) {
  app
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(VueCookies, { expires: '30d', secure: true })
    .use(PerfectScrollbarPlugin)
    .use(initI18n());
}
